import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { FileClockIcon, SearchIcon } from "lucide-react";
import { useLogChangesSystemModels } from "../../hooks/useLogChangesSystemModels";
import Select from "@/common/components/Select";
import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import LogChangesTable from "@/common/components/LogChangesTable";
import { Mapper } from "@/common/services/mapper";
import { LogChangesSystemModel } from "../../types/logs.type";

const LogList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [itemId, setItemId] = useDebounce(filterParams.itemId || '');
  const [searchModel, setSearchModel] = useDebounce('');

  const {
    data: logChangesSystemModelsOptions,
    error: logChangesSystemModelsError = {} as any,
    refetch: refetchLogChangesSystemModels,
  } = useLogChangesSystemModels({
    filters: {
      search: searchModel,
    },
    mapper: Mapper.mapToOptions<LogChangesSystemModel>({ labelFieldName: 'translated_name', valueFieldName: 'klass_name' }),
  });

  return (
    <div>
      <div className="flex flex-col gap-6">
        <ListHeader
          Icon={<FileClockIcon className="w-10 h-10" strokeWidth={1.5} />}
          title="Logs do sistema"
        />

        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={logChangesSystemModelsError?.status}
          refetchFunction={refetchLogChangesSystemModels}
        >
          <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
            <div className="flex md:flex-col lg:flex-row items-center gap-4">
              <Select
                className="shadow-xl md:w-full lg:w-1/2 xl:w-1/4"
                placeholder="Selecione o modelo"
                value={filterParams.model}
                onInputChange={setSearchModel}
                onChange={(e) => setFilterParams((prev) => ({ ...prev, model: e }))}
                options={logChangesSystemModelsOptions}
                isClearable
              />

              <TextField
                LeftIcon={<SearchIcon />}
                placeholder="Digite o ID do item que deseja buscar"
                className="rounded-sm shadow-xl flex-1 w-full"
                onChange={(e) => {
                  setItemId((e.target as HTMLInputElement).value);
                  setFilterParams((prev) => ({ ...prev, itemId: (e.target as HTMLInputElement).value }))
                }}
                value={filterParams.itemId}
              />
            </div>

            {(!filterParams.model?.value || !itemId) && (
              <EmptyDataMessage
                className="bg-white-100 rounded-xl shadow-xl"
                message="Selecione o modelo e digite o ID do item para buscar os logs"
              />
            )}

            {filterParams.model?.value && itemId && (
              <LogChangesTable
                type={filterParams.model.value}
                id={itemId}
                hideSearch
              />
            )}
          </div>
        </ErrorMessageWrapper>
      </div>
    </div>
  );
}

export default LogList;
